const articlePriceUnitSuppDataGenerator = (obj,article,suppPrice) => {
    suppPrice.map((item,index)=>{
        let numero = index+1
        obj['price_unit_'+item['designation_'+numero]]= (article.hasOwnProperty('price_unit_'+item['designation_'+numero]) && article['price_unit_'+item['designation_'+numero]]!==null && article['price_unit_'+item['designation_'+numero]]!=='') ? article['price_unit_'+item['designation_'+numero]] : ''
    })
};

export default articlePriceUnitSuppDataGenerator;